import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';
import BaseFormFieldProps from '../../types/BaseFormFieldProps';

export interface InputLayoutProps {
    label?: string;
    error?: string;
    name: string;
    labelWidth?: number;
    colorTheme?: BaseFormFieldProps['colorTheme'];
    children?: any;
}

const InputLayout = (props: InputLayoutProps) => {
    // TODO add config for breakpoints
    const isFullWidthLabel = window.innerWidth < 576;
    return (
        <div
            className={classnames('input-layout', styles.inputLayout, styles[props.colorTheme], {
                [styles.vertical]: isFullWidthLabel,
            })}
        >
            {!!props.label && (
                <label htmlFor={props.name} className={`${styles.label} form-label`} style={{ width: props.labelWidth }}>
                    {props.label}
                </label>
            )}
            <div className={`${styles.inputGroup} input-layout-group`}>
                {props.children}
                {!!props.error && <div className={classnames(styles.errorMessage, 'form-error-message')}>{props.error}</div>}
            </div>
        </div>
    );
};
InputLayout.defaultProps = {
    label: '',
    error: '',
    labelWidth: 140,
    colorTheme: 'light',
    children: null,
};

export default InputLayout;
